/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RequestType
 */
export interface RequestType {
    /**
     *
     * @type {string}
     * @memberof RequestType
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof RequestType
     */
    id: number;
    /**
     *
     * @type {string}
     * @memberof RequestType
     */
    value: string;
}

export function RequestTypeFromJSON(json: any): RequestType {
    return RequestTypeFromJSONTyped(json, false);
}

export function RequestTypeFromJSONTyped(json: any, _: boolean): RequestType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'name': json['name'],
        'id': json['id'],
        'value': json['value'],
    };
}

export function RequestTypeToJSON(value?: RequestType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'name': value.name,
        'id': value.id,
        'value': value.value,
    };
}
